import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  IconButton,
  Radio,
  RadioGroup,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';

import AddressDropdown from './AddressDropdown';
import Contact from './Contact';
import { useState } from 'react';
import DragDropUpload from './DragDropUpload';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface Props {
  data: Record<string, any>;
  onChange: (field: string, value: any) => void;
  errors?: { [key: string]: string };
  handleSetFullAddress: (fullAddress: {
    address: string;
    address2: string;
    city: string;
    state: string;
    zip: string;
  }) => void;
}

const BillingInformation = (props: Props) => {
  const handleFileAccepted = (file: File) => {
    props.onChange('taxExemptFile', file);
  };
  
  return (
    <Box
      sx={{
        padding: '20px',
      }}
    >
      <Stack
        width={{ xs: '100%', sm: '90%', md: '80%', lg: '60%' }}
        maxWidth='800px'
        minWidth='200px'
        position={'relative'}
      >
        <Typography style={{ color: '#808080', fontSize: 28 }}>
          Billing Information
        </Typography>
        <Tooltip
          title='If your facility has designated staff to handle billing please fill out the fields below'
          sx={{ position: 'absolute', top: 4, left: 240 }}
        >
          <IconButton size='small'>
            <InfoOutlinedIcon fontSize='small' />
          </IconButton>
        </Tooltip>
        <FormGroup sx={{ marginTop: 2 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={props.data.sameAsShipping}
                onChange={(e) =>
                  props.onChange('sameAsShipping', e.target.checked)
                }
                value='yes'
                name='yes'
                color='info'
              />
            }
            label='Same as Shipping'
          />
        </FormGroup>
        {!props.data.sameAsShipping && (
          <Stack>
            <AddressDropdown
              setAddress1={(value: any) => props.onChange('address', value)}
              setFullAddress={props.handleSetFullAddress}
              inputValue={props.data.address || ''}
              data={props.data}
              errorKey='billingAddress'
              onChange={props.onChange}
              errorCityKey='billingCity'
              errorStateKey='billingState'
              errorZipKey='billingZip'
              errors={props.errors}
            />
          </Stack>
        )}
        <Typography style={{ color: '#808080', fontSize: 22, marginTop: 50 }}>
          Billing Contact Information
        </Typography>
        <Contact
          contact={props.data.contact}
          handleChange={props.onChange}
          errors={props.errors ?? {}}
          errorKey='billingContact'
        />
        <FormControl style={{ marginTop: 32 }}>
          <FormLabel>Is your Company Tax Exempt?</FormLabel>
          <RadioGroup
            row
            name='isTaxExempt'
            value={props.data.isTaxExempt === true ? 'true' : 'false'}
            onChange={(e) =>
              props.onChange('isTaxExempt', e.target.value === 'true')
            }
          >
            <FormControlLabel value='true' control={<Radio />} label='Yes' />
            <FormControlLabel value='false' control={<Radio />} label='No' />
          </RadioGroup>
        </FormControl>
        {props.data.isTaxExempt && (
          <Stack marginTop={4}>
            <DragDropUpload
              onFileAccepted={handleFileAccepted}
              maxFiles={3}
              hasError={props.errors?.billingTaxExempt}
              file={props.data.taxExemptFile}
            />
          </Stack>
        )}
      </Stack>
    </Box>
  );
};

export default BillingInformation;
